import { LegacyStack, Tag, Autocomplete, Icon, InlineError } from '@shopify/polaris';
import __helpers from 'helpers/index';
import { useMutateGetProductCategories } from 'queries/product_category.query';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { SearchIcon, PlusCircleIcon } from '@shopify/polaris-icons';
import ProductCategoryModalAddAndEdit from 'entities/product/product_category/product_category.edit.modal';
import useDidMountEffect from './useDidMountEffect';

/** Phiên bản cải tiến tìm nhanh một product category, bản cải tiến triệt để ... */
export default function QuickSearchProductCategory2({
  current_category_id = [],
  label = 'Ngành hàng/danh mục sản phẩm',
  errorMessage = '',
  onClose,
  allowMultiple = true,
}: {
  current_category_id: any[];
  errorMessage?: string;
  label: string;
  onClose: (val: string[]) => void;
  allowMultiple?: boolean;
}) {
  /******************************** *
   * ADVANCE PRODUCT CATEGORY ...
   ******************************** */
  const initialQuery = useMemo(() => {
    return {
      category_id: '', // trong trường hợp mà nó lưu sẵn rồi thì có thể để vào đây!
      limit: 10,
      query: '',
      category_status: 1,
      sort: 'createdAt:desc',
    };
  }, []);

  const [productCategoryQuery, setProductCategoryQuery] = useState(initialQuery);
  const { mutateAsync: refetchProductCategory, isPending: searchingCategory, data: entities } = useMutateGetProductCategories();

  /** Lấy thêm data nếu có current_category_id, thay vì 1, thì thêm tí nữa */
  const fetchInitialData = useCallback(async () => {
    await __helpers.sleep(1000);
    refetchProductCategory({
      limit: 5,
      sort: 'createdAt:desc',
    });
  }, []);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const reduceProductCategoryRequest = useCallback((mainQuery) => {
    refetchProductCategory(mainQuery);
    return mainQuery;
  }, []);

  const reduceRequestProductCategoryMemo = useMemo(() => {
    return __helpers.debounce((_value) => {
      reduceProductCategoryRequest?.call(this, _value);
    }, 500);
  }, []);

  useEffect(() => {
    reduceRequestProductCategoryMemo(productCategoryQuery);
  }, [productCategoryQuery, reduceRequestProductCategoryMemo]);

  /** Lưu cache hết lại để hiển thị cái tên trùng với cái ID chết tiệt ... */
  const cacheProductCategoryData = useRef<any[]>([]);
  const [selectedOptions3, setSelectedOptions3] = useState<string[]>([]);
  const [inputValue3, setInputValue3] = useState<string>('');
  const [options3, setOptions3] = useState([]);

  /** sửa lỗi: Khhi không cái gì được chọn, phải rỗng */
  useEffect(() => {
    if (!allowMultiple && selectedOptions3.length === 0) {
      setInputValue3('');
    }
  }, [selectedOptions3, allowMultiple]);

  /** Chỉ khi hiện tại khác với current thì mới gọi sang bên kia ... */
  const handleClose = useCallback(
    (selected: any[]) => {
      if (JSON.stringify(current_category_id) !== JSON.stringify(selected)) {
        onClose(selected);
      }
    },
    [current_category_id, onClose]
  );

  useDidMountEffect(() => {
    handleClose(selectedOptions3);
  }, [selectedOptions3]);

  const afterCreateProductCategoryCallback = useCallback(
    (newProductCategoryEntity: any) => {
      setShowQuickCreate(false);
      if (newProductCategoryEntity) {
        if (allowMultiple) {
          setSelectedOptions3((old) => [...old, ...[newProductCategoryEntity.category_id]]);
        } else {
          setSelectedOptions3((old) => [newProductCategoryEntity.category_id]);
        }
        cacheProductCategoryData.current.push(newProductCategoryEntity);
      }
    },
    [allowMultiple]
  );

  /**
   * Yêu cầu chỉ được nạp lần đầu tiên, không được nạp lại ...
   */
  let alreadyTakeCurrentCategory = useRef(false);
  useEffect(() => {
    if (current_category_id && alreadyTakeCurrentCategory.current === false) {
      let __current_category_id = current_category_id.filter((el) => __helpers.isBigInt(el));
      setSelectedOptions3(__current_category_id);
      alreadyTakeCurrentCategory.current = true;
      setProductCategoryQuery((old) => {
        return { ...old, category_id: __current_category_id.join(',') };
      });
    }
  }, [current_category_id]);

  /** Khối này theo dõi entities và nhét vào cache, sau đó nhét vào danh sách */

  const deselectedOptions3 = useCallback(
    (entities) => {
      const results = entities.body.map((productcategory: any) => {
        cacheProductCategoryData.current.push(productcategory);
        return {
          label: productcategory.category_name,
          value: String(productcategory.category_id),
        };
      });
      setOptions3(results);
    },
    [cacheProductCategoryData.current]
  );

  useEffect(() => {
    if (!entities && typeof entities?.body === 'undefined') return;
    deselectedOptions3(entities);
  }, [entities]);

  const updateText3 = useCallback(
    (value: string) => {
      setInputValue3(value);
      //   if (!value) return;
      let N = {
        ...productCategoryQuery,
        ...{
          query: value,
          category_id: '' /** unset category_id ddi */,
        },
      };
      setProductCategoryQuery(N);
    },
    [productCategoryQuery]
  );

  const updateSelectedCallback = useCallback(
    (selected: any[]) => {
      setSelectedOptions3(selected);

      // Lấy nhãn (label) từ `options3` và cập nhật `inputValue3`
      if (!allowMultiple && selected.length > 0) {
        const selectedOption = options3.find((option) => option.value === selected[0]);
        setInputValue3(selectedOption?.label || '');
      }
    },
    [selectedOptions3, options3, allowMultiple]
  );

  const removeTag3 = useCallback(
    (tag: string) => () => {
      const selected = [...selectedOptions3];
      selected.splice(selected.indexOf(tag), 1);
      setSelectedOptions3(selected);
    },
    [selectedOptions3]
  );

  const [showQuickCreate, setShowQuickCreate] = useState(false);
  const verticalContentMarkup3 =
    selectedOptions3.length > 0 ? (
      <LegacyStack spacing="extraTight" alignment="center">
        {selectedOptions3.map((option) => {
          if (!option) return null;
          let tagInCache = cacheProductCategoryData.current.find((el) => BigInt(el.category_id) === BigInt(option));
          let tagLabel = tagInCache?.category_name || option;
          return (
            <Tag key={`option${option}`} onRemove={removeTag3(option)}>
              {tagLabel}
            </Tag>
          );
        })}
      </LegacyStack>
    ) : null;

  return (
    <>
      <Autocomplete
        actionBefore={{
          accessibilityLabel: 'Tạo danh mục mới',
          content: 'Tạo một danh mục mới',
          ellipsis: true,
          helpText: 'Tạo danh mục mới và chỉnh sửa sau',
          icon: PlusCircleIcon,
          onAction: () => {
            setShowQuickCreate(!showQuickCreate);
          },
        }}
        allowMultiple={allowMultiple}
        loading={searchingCategory}
        options={options3}
        selected={selectedOptions3}
        textField={
          <>
            <Autocomplete.TextField
              onChange={updateText3}
              label={label}
              error={errorMessage ? true : false}
              placeholder="Chọn một danh mục"
              value={inputValue3}
              prefix={<Icon source={SearchIcon} tone="base" />}
              verticalContent={verticalContentMarkup3}
              autoComplete="off"
            />
            <div style={{ marginTop: '4px' }}>
              <InlineError message={errorMessage} fieldID="TextFieldSelectCategory" />
            </div>
          </>
        }
        onSelect={updateSelectedCallback} // setSelectedOptions3
        listTitle="Danh sách danh mục"
      />

      <ProductCategoryModalAddAndEdit
        show={showQuickCreate}
        onClose={(productCategoryNewData) => afterCreateProductCategoryCallback(productCategoryNewData)}
      />
    </>
  );
}

